type InputErrorTextProps = {
  children: string
}
import { IoCloseCircle } from 'react-icons/io5'
export const InputErrorText = ({ children }: InputErrorTextProps) => (
  <p className='font-medium text-sm mt-1 text-[#DE3333] flex items-center'>
    <IoCloseCircle className='text-[#DE3333] mr-2' />
    {children}
  </p>
)
